import React, { useRef, useState } from 'react';
import '../../styles/accountForms.css';
import { useNavigate } from 'react-router-dom';
import { FaFacebook, FaGithub, FaLinkedin, FaTwitter, FaCloudUploadAlt } from 'react-icons/fa';
import { FcRemoveImage } from 'react-icons/fc';
import { displaySnackbar } from '../../utilities';
import { BASE_URL } from '../../settings';

export default function Signup({ setScreen }) {
    const [email, setEmail] = useState();
    const [username, setUsername] = useState();
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [mobile, setMobile] = useState();
    const [githubLink, setGithubLink] = useState();
    const [linkedInLink, setLinkedInLink] = useState();
    const [facebookLink, setFacebookLink] = useState();
    const [twitterLink, setTwitterLink] = useState();
    const [classYear, setClassYear] = useState();
    const [positionName, setPositionName] = useState();
    const [about, setAbout] = useState();
    const [password, setPassword] = useState();
    const [confirmPassword, setConfirmPassword] = useState();
    const [avatar, setAvatar] = useState();
    const [temporaryAvatar, setTemporaryAvatar] = useState(
        require('../../images/profile-pictures/face1.jpg')
    );
    const [isAvatarUploaded, setIsAvatarUploaded] = useState(false);
    const openFileRef = useRef();
    const [showLoading, setShowLoading] = useState(false);

    // 👇️ handler to upload alumni profile picture (avatar)
    const uploadAvatar = (e) => {
        setShowLoading(true);
        const file = e.target.files[0];

        if (file) {
            setAvatar(file?.name);
            const formData = new FormData();
            formData.append('alumni-profile-image', file);

            fetch(`${BASE_URL}/alumni/profile-pic-upload`, {
                method: 'POST',
                body: formData,
            })
                .then(async (result) => {
                    setShowLoading(false);
                    let response = await result.json();
                    if (response?.errorMsg) {
                        displaySnackbar(response?.errorMsg, true);
                        setIsAvatarUploaded(false);
                    } else {
                        setTemporaryAvatar(
                            `${BASE_URL}/alumni/uploads/get-profile-pic/${file?.name}`
                        );
                        setIsAvatarUploaded(true);
                        displaySnackbar(response?.msg, false);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                        console.log('the error:', error);
                    }
                    setShowLoading(false);
                });
        }
    };

    // 👇️ handler to remove uploaded alumni profile pic (avatar)
    const removeUploadedAvatar = () => {
        if (avatar) {
            fetch(`${BASE_URL}/alumni/remove-profile-pic`, {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image: avatar }),
            })
                .then(async (result) => {
                    setShowLoading(false);
                    let response = await result.json();
                    if (response?.errorMsg) {
                        displaySnackbar(response?.errorMsg, true);
                    } else {
                        setIsAvatarUploaded(false);
                        setTemporaryAvatar(require('../../images/profile-pictures/face1.jpg'));
                        displaySnackbar(response?.msg, false);
                        openFileRef.current.value = '';
                        setAvatar(null);
                    }
                })
                .catch((error) => {
                    if (error?.message == 'Failed to fetch') {
                        displaySnackbar('Could not reach the servers', true, 'Ok', () => {});
                    } else {
                        displaySnackbar('Some error occurred!', true, 'Ok', () => {});
                        console.log('the error:', error);
                    }
                    setShowLoading(false);
                });
        }
    };

    // 👇️ handler for sign up alumni.
    const signup = () => {
        setShowLoading(true);

        if (email && email?.length > 0 && isNaN(email) && email?.trim()) {
            if (username && username?.length > 0 && isNaN(username) && username?.trim()) {
                if (firstName && firstName?.length > 0 && isNaN(firstName) && firstName?.trim()) {
                    if (lastName && lastName?.length > 0 && isNaN(lastName) && lastName?.trim()) {
                        if (
                            password &&
                            password?.length > 0 &&
                            Number(password) != 0 &&
                            password?.trim()
                        ) {
                            if (password === confirmPassword) {
                                fetch(`${BASE_URL}/alumni/signup`, {
                                    method: 'POST',
                                    headers: { 'Content-Type': 'application/json' },
                                    body: JSON.stringify({
                                        email,
                                        username,
                                        firstName,
                                        lastName,
                                        githubLink,
                                        linkedInLink,
                                        facebookLink,
                                        twitterLink,
                                        classYear: classYear
                                            ? new Date(classYear).getFullYear()
                                            : new Date().getFullYear(),
                                        positionName: positionName ? positionName : 'Not employed',
                                        about,
                                        password,
                                        mobile,
                                        avatar,
                                    }),
                                })
                                    .then(async (result) => {
                                        setShowLoading(false);
                                        let response = await result?.json();
                                        if (response?.msg === null) {
                                            displaySnackbar(response?.errorMsg, true);
                                        } else {
                                            console.log(response);
                                            displaySnackbar(response?.msg, false);
                                            setScreen('Login');
                                        }
                                    })
                                    .catch((error) => {
                                        if (error?.message == 'Failed to fetch') {
                                            displaySnackbar('Could not reach the servers', true);
                                        } else {
                                            console.log('the error:', error);
                                            displaySnackbar('Some error occurred!', true);
                                        }
                                        setShowLoading(false);
                                    });
                            } else {
                                setShowLoading(false);
                                displaySnackbar("Passwords don't match");
                            }
                        } else {
                            setShowLoading(false);
                            displaySnackbar('Provide password!', true);
                        }
                    } else {
                        setShowLoading(false);
                        displaySnackbar('Provide last name!', true);
                    }
                } else {
                    setShowLoading(false);
                    displaySnackbar('Provide first name!', true);
                }
            } else {
                setShowLoading(false);
                displaySnackbar('Provide username!', true);
            }
        } else {
            setShowLoading(false);
            displaySnackbar('Provide email!', true);
        }
    };

    return (
        <div className='alumni-login-container'>
            <div className='login-container'>
                <h1 className='form-header'>Alumni Sign Up</h1>

                <div className='form-inputs'>
                    <div
                        className='temporary-upload-image-container'
                        title={isAvatarUploaded ? '' : 'image should be less than 2MB'}
                    >
                        <img src={temporaryAvatar} alt='' className='temporary-upload-image' />
                    </div>

                    {isAvatarUploaded ? (
                        <button
                            className='upload-avatar-btn remove-avatar-btn'
                            onClick={removeUploadedAvatar}
                        >
                            Remove Profile Picture{' '}
                            {<FcRemoveImage size={25} style={{ marginLeft: '1rem' }} />}
                        </button>
                    ) : (
                        <button
                            className='upload-avatar-btn'
                            title='image should be less than 2MB'
                            onClick={() => openFileRef.current?.click()}
                        >
                            Upload Profile Picture{' '}
                            {<FaCloudUploadAlt size={25} style={{ marginLeft: '1rem' }} />}
                        </button>
                    )}

                    <input
                        type='file'
                        name='alumni-profile-image'
                        placeholder='Profile Pic'
                        // value={avatar}
                        hidden
                        ref={openFileRef}
                        onChange={(e) => uploadAvatar(e)}
                    />

                    <input
                        type='email'
                        name='email'
                        placeholder='Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type='text'
                        name='username'
                        placeholder='Username'
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <input
                        type='text'
                        name='firstName'
                        placeholder='First name'
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                    />

                    <input
                        type='text'
                        name='lastName'
                        placeholder='Last name'
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    />

                    <input
                        type='tel'
                        name='mobile'
                        placeholder='Mobile number e.g 7x-xxx-xxxx'
                        value={mobile}
                        maxLength={9}
                        max={9}
                        onChange={(e) => {
                            let value = e.target.value;
                            value = value?.replace(/^(\d{2})(\d{3})(\d{4})/g, '$1-$2-$3');
                            setMobile(value);
                        }}
                    />

                    <div className='input-with-icon'>
                        <FaGithub className='input-icon' size={25} />
                        <input
                            type='url'
                            id='githubLink'
                            name='githubLink'
                            placeholder='Github Link'
                            value={githubLink}
                            onChange={(e) => setGithubLink(e.target.value)}
                        />
                    </div>
                    <div className='input-with-icon'>
                        <FaLinkedin color='darkblue' className='input-icon' size={25} />
                        <input
                            type='url'
                            name='linkedInLink'
                            placeholder='LinkedIn link'
                            value={linkedInLink}
                            onChange={(e) => setLinkedInLink(e.target.value)}
                        />
                    </div>
                    <div className='input-with-icon'>
                        <FaFacebook color='darkblue' className='input-icon' size={25} />
                        <input
                            type='url'
                            name='facebookLink'
                            placeholder='Facebook link'
                            value={facebookLink}
                            onChange={(e) => setFacebookLink(e.target.value)}
                        />
                    </div>

                    <div className='input-with-icon'>
                        <FaTwitter color='skyblue' className='input-icon' size={25} />
                        <input
                            type='url'
                            name='twitterLink'
                            placeholder={'Twitter Link'}
                            value={twitterLink}
                            onChange={(e) => setTwitterLink(e.target.value)}
                        />
                    </div>

                    <label htmlFor='classYear'>Graduating year</label>
                    <input
                        style={{ marginTop: '0' }}
                        type='date'
                        id='classYear'
                        name='classYear'
                        placeholder={`graduating year e.g ${new Date().getFullYear()}`}
                        value={classYear}
                        onChange={(e) => setClassYear(e.target.value)}
                    />

                    <input
                        type='text'
                        name='positionName'
                        placeholder='Current employment position e.g Software Engineer'
                        value={positionName}
                        onChange={(e) => setPositionName(e.target.value)}
                    />
                    <textarea
                        type='text'
                        name='about'
                        placeholder='About you...'
                        rows={5}
                        value={about}
                        onChange={(e) => setAbout(e.target.value)}
                    />
                    <input
                        type='password'
                        name='password'
                        placeholder='Password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input
                        type='password'
                        name='confirm password'
                        placeholder='Confirm Password'
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                </div>

                <button
                    className='action-btn'
                    onClick={signup}
                    disabled={
                        showLoading || !email || !username || !firstName || !lastName || !classYear
                    }
                    style={{
                        backgroundColor:
                            showLoading ||
                            !email ||
                            !username ||
                            !firstName ||
                            !lastName ||
                            !classYear
                                ? '#aaa'
                                : 'darkblue',
                        color:
                            showLoading ||
                            !email ||
                            !username ||
                            !firstName ||
                            !lastName ||
                            !classYear
                                ? '#333'
                                : '#eee',
                    }}
                >
                    Signup
                </button>

                <span className='link' onClick={() => setScreen('login')}>
                    👈️ Back to login.
                </span>
            </div>
        </div>
    );
}
